import { render, staticRenderFns } from "./mPaymentPosting.vue?vue&type=template&id=55411bc8&"
import script from "./mPaymentPosting.vue?vue&type=script&lang=js&"
export * from "./mPaymentPosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports